module.exports = __webpack_public_path__ + "img/mine-active.c1a11fc4.png";